"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearanceLevel = exports.SSR_HYDRATE_KEYWORD = exports.WIKI_NAME = void 0;
exports.WIKI_NAME = 'scp-ru';
exports.SSR_HYDRATE_KEYWORD = '__ssr_hydrate__';
var ClearanceLevel;
(function (ClearanceLevel) {
    ClearanceLevel["Guest"] = "guest";
    ClearanceLevel["User"] = "user";
})(ClearanceLevel = exports.ClearanceLevel || (exports.ClearanceLevel = {}));
//# sourceMappingURL=constants.js.map